import { render, staticRenderFns } from "./client-plans.vue?vue&type=template&id=341fdac7"
import script from "./client-plans.vue?vue&type=script&lang=js"
export * from "./client-plans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports